module.exports = __webpack_public_path__ + "media/assets/HWE_audio_visual_experience-3918f2d2d8aca6013fe844db5df5355f.jpg";